import BunkeyAPI from '../api/BunkeyAPI'
import {
  BITACORA_GET_DATA,
  BITACORA_GET_DATA_SUCCESS,
  BITACORA_GET_DATA_FAILURE,
} from '../constants/bitacora-types'

export const getBitacora = activePage => {
  return dispatch => {
    dispatch({ type: BITACORA_GET_DATA })
    BunkeyAPI({
      url: `/log?page=${activePage}&limit=10`,
      method: 'GET',
    }).then(resp => {
      dispatch({
        type: BITACORA_GET_DATA_SUCCESS,
        payload: {
          data: resp.data,
          headers: resp.headers
        }
      })
    }).catch(err => {
      dispatch({
        type: BITACORA_GET_DATA_FAILURE,
        payload: err
      })
    })
  }
}